import { LitElement, html, css } from "lit";
import language from "#scripts/translation";

export class MyPageRealestateList extends LitElement {
  static properties = {
    ssn: { type: String },
  };

  static styles = css`
    :host {
      width: 100%;
    }

    .list__container {
      margin-inline: auto;
      //margin-top: 80px;
      padding-bottom: 30px;
      width: 100%;
      max-width: 1140px; 
      /* display: flex; */
      justify-content: space-between;
      @media(max-width: 768px) {
        flex-direction: column;
        border-top: none;
        padding-top: 0px;
        margin-top: 0px;
      }
    }
    .list__items {
      /* display: flex; */
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      flex-wrap: wrap;
      gap: 30px;
      @media(max-width: 768px) {
        padding-inline: 15px;
        grid-template-columns: 1fr;
      }
    }
    /* HTML: <div class="loader"></div> */
    .loader {
      align-self: center;
      width: 50px;
      padding: 8px;
      aspect-ratio: 1;
      border-radius: 50%;
      background: var(--spinner-color, var(--primary__color, #444));
      --_m: 
        conic-gradient(#0000 10%,#000),
        linear-gradient(#000 0 0) content-box;
      -webkit-mask: var(--_m);
              mask: var(--_m);
      -webkit-mask-composite: source-out;
              mask-composite: subtract;
      animation: l3 1s infinite linear;
    }
    @keyframes l3 {to{transform: rotate(1turn)}}
  `;

  // constructor() {
  //   super();
  // }

  render () {
    const socialSecurityNumber = this.ssn;
    getRealestates(socialSecurityNumber).then((data) => {
      const realestateList = document.querySelector("mypage-realestate-list");
      const realestateError = document.createElement("mypage-realestate-error");
      if (data.status !== undefined && data.status !== 200) {
        if (data.status === 404) {
          realestateError.message = language("MYPAGE_REALESTATE_CONFIG_ERROR");
        } else {
          realestateError.message = `${data.title} - ${data.detail}`;
        }
        realestateList.appendChild(realestateError);
      } else if (data.matrikler.length < 1) {
        realestateError.message = language("MYPAGE_REALESTATE_NOREALESTATE");
        realestateList.appendChild(realestateError);
      } else {
        for (const item of data.matrikler) {
          const realestateCard = document.createElement("mypage-realestate-item");
          realestateCard.item = item;
          realestateList.appendChild(realestateCard);
        }
      }
    });

    return html`
      <div class="list__container">
        <div class="list__items">
          <slot><div class="loader"></div></slot>
        </div>
      </div>`;
  }
}

export class MyPageRealestateItem extends LitElement {
  static properties = {
    item: { type: Object, reflect: true },
  };

  static styles = css`
    :host {
      display: contents;
      height: min-content;
    }
    .material-icons-outlined,
    .material-symbols-outlined {
      font-family: 'Material Icons Outlined';
      font-weight: normal;
      font-style: normal;
      font-size: 24px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-smoothing: antialiased;
    }
    .material-symbols-outlined {
      font-family: 'Material Symbols Outlined';
    }
    .item {
      flex: 1  1 48.5%;
      display: flex;
    }
    .item__wrapper {
      background: var(--minside__menu__item_bg, #ffffff);
      border: 6px solid var(--minside__menu__item_bg, #ffffff);
      border-radius: var(--minside__menu__item_border-radius, 6px);
      display: flex;
      flex-direction: column;
      width: -webkit-fill-available;
      margin-bottom: 0!important;
      padding: 40px 30px 50px 30px;
      align-items: flex-start;
      gap: 20px;
      @media(max-width: 768px) {
        padding-inline: 15px;
        padding: 14px 14px 24px 14px;
      }
    }
    .title__wrapper {
      display: flex;
      gap: 20px;
    }
    .item__info {
      display: flex;
      flex-direction: column;
      width: -webkit-fill-available;
    }
    .item__icon {
      height: 50px;
      min-width: 37px;
      justify-content: center;
    }
    .item__icon img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .item__title {
        font-size: 1.5rem;
        margin: 0 0 15px 0;
    }
    .item__text {
      font-size: 1rem;
      margin: 0;
      display: flex;
      margin-bottom: 8px;
      align-items: flex-start;
      gap: 8px;
      align-self: stretch;
      border-bottom: 1px solid rgba(0, 0, 0, 0.30);
      display: flex;
      padding-bottom: 5px;
    }
    .grow {
      flex-grow: 1;
    }
    .label {
      font-weight: var(--f-w-3);
      width: 150px;
    }
    .item__link {
      text-decoration: none;
      color: var(--fullnav__main__link_color,#333);
      display: flex;
      gap: 6px;
      &:first-of-type {
        margin-top: 45px;
      }
      & div {
        text-decoration: underline;
      }    
      @media(max-width: 768px) {
        font-size: 1rem;
      }  
      
    }
    .item__link:hover div {
      /* text-decoration: underline; */
      color: var(--fullnav__main__link_color_hover,#333);
      text-decoration-thickness: 2px;
    }
    .spacer {
      height: 45px;
    }
  `;

  // constructor() {
  //   super();
  // }

  render () {
    const cadastre = this.item?.matrikkelnummer;
    const fullCadastre = `${cadastre?.kommunenummer}-${cadastre?.gardsnummer}/${cadastre?.bruksnummer}/${cadastre?.festenummer}/${cadastre?.seksjonsnummer}`;

    const adresse = this.item?.adresser[0];
    const municName = this.item?.kommuneNavn || "";

    let veg = adresse?.veg != null ? adresse.veg : "";
    let nummer = adresse?.nummer != null ? adresse.nummer : "";
    let bokstav = adresse?.bokstav != null ? adresse.bokstav : "";

    let fullAdresse = adresse !== undefined
      ? `${veg} ${nummer}${bokstav}`
      : fullCadastre;

    const icon = `https://static.fiks.ks.no/img/kommunevaapen/${cadastre?.kommunenummer}.png`;

    if (fullAdresse === "") {
      fullAdresse = fullCadastre;
    }

    const extraLinks = [];
    if (window.serverdata.configMeta.aim.mysite.realestate?.links) {
      for (const link of window.serverdata.configMeta.aim.mysite.realestate.links) {
        extraLinks.push(html`<a class="item__link" href="${link.url}" target="_blank" aria-label="${link.title} (${language("NAV_OPEN_I_NEW")})">
          <div>${link.title}</div>
          <span class="material-icons-outlined">open_in_new</span>
        </a>`);
      }
    }

    return html`
      <div class="item">
        <div class="item__wrapper">
          <div class="title__wrapper">
            <div class="item__icon"><img loading="lazy" src="${icon}" /></div>
            <h2 class="item__title">${fullAdresse}</h2>
          </div>
          <div class="item__info">
            <div class="item__text">
              <div class="label">${language("MYPAGE_REALESTATE_MUNICIPALITY")}</div>
              <div class="grow">${cadastre?.kommunenummer} ${municName}</div>
            </div>
            <div class="item__text">
              <div class="label">${language("MYPAGE_REALESTATE_GARDS_NR")}</div>
              <div class="grow">${cadastre?.gardsnummer}</div>
            </div>
            <div class="item__text">
              <div class="label">${language("MYPAGE_REALESTATE_BRUKS_NR")}</div>
              <div class="grow">${cadastre?.bruksnummer}</div>
            </div>
            <div class="spacer"></div>
            <div class="item__text">
              <div class="label">${language("MYPAGE_REALESTATE_ADDRESS")}</div>
              <div class="grow">${fullAdresse}</div>
            </div>
            <div class="item__text">
              <div class="label">${language("MYPAGE_REALESTATE_MATRIKKEL_NR")}</div>
              <div class="grow">${fullCadastre}</div>
            </div>
            <a class="item__link" href="https://seeiendom.kartverket.no/eiendom/${cadastre?.kommunenummer}/${cadastre?.gardsnummer}/${cadastre?.bruksnummer}" target="_blank" aria-label="${language("MYPAGE_REALESTATE_EXTERNAL_LINK")} (${language("NAV_OPEN_I_NEW")})">
                <div>${language("MYPAGE_REALESTATE_EXTERNAL_LINK")}</div>
                <span class="material-icons-outlined">open_in_new</span>
            </a>
            ${extraLinks}
          </div>
        </div>
      </div>`;
  }
}

export class MyPageRealestateError extends LitElement {
  static properties = {
    message: { type: String },
  };

  static styles = css`
    .item {
      background: #ffffff;
      border-radius: 6px;
      padding: 20px 25px 20px 25px;
      display: flex;
      flex-direction: row;
      gap: 20px;
      align-items: center;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
    }
    .icon {
      padding: 5px 0px 0px 0px;
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: flex-start;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
      flex-shrink: 0;
      width: 37px;
      height: auto;
      position: relative;
      img {
        // width: 32px;
        height: 50px;
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    }
    .title {
      display: flex;
      flex-direction: row;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-family: var(
        --raelingen-h3-font-family,
        "SourceSansPro-SemiBold",
        sans-serif
      );
      font-size: var(--raelingen-h3-font-size, 20px);
      line-height: var(--raelingen-h3-line-height, 150%);
      font-weight: var(--raelingen-h3-font-weight, 600);
      position: relative;
      flex: 1;
    }
    .text {
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-family: "SourceSansPro-Regular", sans-serif;
      font-size: 16px;
      line-height: 135%;
      font-weight: 400;
      position: relative;
      align-self: stretch;
    }
    .more-icon {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: flex-end;
      justify-content: center;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    }
    .arrow-forward {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      position: relative;
      overflow: visible;
    }
    .pill {
      background: #eeeeee;
      border-radius: 40px;
      padding: 4px 11px 4px 11px;
    }
    .amount {
      font-weight: 600;
    }
    .paid {
      background: #d6f3c0;
    }`;

  // constructor() {
  //   super();
  // }

  render () {
    return html`${this.message}`;
  }
}

customElements.define("mypage-realestate-list", MyPageRealestateList);
customElements.define("mypage-realestate-item", MyPageRealestateItem);
customElements.define("mypage-realestate-error", MyPageRealestateError);

const getRealestates = async (ssn) => {
  if (!window.location.host.match(/localhost/gim)) {
    // **********************************
    // * https://min.kommune.no/innsyn-sok/api/v1/eiendom/sok?term=best&fra=0&antall=15&akseptertMeldingVersjon=matrikkelenhetV1
    // *
    // * eller
    // *
    // * POST /matrikkel-eier/api/v1/{fiksOrgId}/finn-eiendommer
    // * https://prokom-aimcms-dev.azurewebsites.net/proxy/ksfiks/f0d2b5fc-3915-45e1-a45f-8d1ad6795cac/finn-eiendommer
    // * PayLoad:
    // * {
    // *   "type": "JURIDISK_PERSON",
    // *   "verdi": "string"
    // * }
    // **********************************

    const fiksOrgId = window.serverdata.configMeta?.integrations?.fiksOrgId;
    const apiUrl = window.apiUrl.replace("/api", "/proxy");
    const apiCall = `${apiUrl}/ksfiks/matrikkel/${fiksOrgId}/finn-eiendommer`;
    const body = {
      type: "JURIDISK_PERSON",
      verdi: ssn,
    };

    return await fetch(apiCall, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        SubscriptionId: `${window.serverdata.configMeta.aim.clientId}`,
        // Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(body),
    })
      .then((results) => results.json())
      .then((data) => {
        return data;
      });
  }
  return JSON.parse(`
	  {
	    "matrikler": []
	  }`);
};
